import { render, staticRenderFns } from "./VoiceGuide.vue?vue&type=template&id=e3096f48&scoped=true"
import script from "./VoiceGuide.vue?vue&type=script&lang=js"
export * from "./VoiceGuide.vue?vue&type=script&lang=js"
import style0 from "./VoiceGuide.vue?vue&type=style&index=0&id=e3096f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3096f48",
  null
  
)

export default component.exports